import { campaignTagsEnum } from "../types/placement"
import { placementsEnum } from "../types/types"

export const PLACEMENTS_COUNT = 6

export const COLORS_BY_TAG: Record<campaignTagsEnum, string> = {
  [campaignTagsEnum.RANKING]: "green",
}

export const PLACEMENT_ROW_ORDER: placementsEnum[] = [
  placementsEnum.TOP_OF_SEARCH,
  placementsEnum.REST_OF_SEARCH,
  placementsEnum.PRODUCT_PAGE,
  placementsEnum.AMAZON_BUSINESS,
  placementsEnum.FEATURED_VIDEOS,
  placementsEnum.AUDIENCE,
]
